import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString } from "vue"

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DurationComponent',
  props: {
  seconds: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const durationString = computed(() => {
  const h = Math.floor(props.seconds / 3600);
  const m = Math.floor(props.seconds / 60) % 60;
  const s = props.seconds % 60;
  const hs = h > 0 ? [`${h}h`] : [];
  const ms = m > 0 ? [`${m}m`] : [];
  const ss = s > 0 ? [`${s}s`] : [];
  return [...hs, ...ms, ...ss].join(' ');
});

return (_ctx: any,_cache: any) => {
  return _toDisplayString(_unref(durationString))
}
}

})